module.exports = __webpack_public_path__ + "img/rightcalf.c32311c0.svg";